"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SseKmsEncryptedObjects = {
    type: "structure",
    required: ["Status"],
    members: {
        Status: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_SseKmsEncryptedObjects.js.map